import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import OrderManager from '../services/api/OrderManager';
import { ORDER_PAYMENT_STATUSES } from '../services/exports/Constants';
import ReduxActions from '../store/ReduxActions';
import { actionCreators } from '../store/actions';
import useOrderFlow from '../hooks/order/useOrderFlow';

const QueryParamKey = 'order_draft_uuid';

export default function OrderDraftPreloader() {
  const { setDraft, setDraftUuid, setRetryOrderUuid } = useOrderFlow();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    preloadOrder();
  }, []);

  async function preloadOrder(): Promise<void> {
    if (!searchParams.has(QueryParamKey)) {
      return;
    }

    const { success, response } = await OrderManager.getOrder(searchParams.get(QueryParamKey));

    if (!success || response.data.data.payment_status !== ORDER_PAYMENT_STATUSES.PENDING) {
      searchParams.delete(QueryParamKey);

      return setSearchParams(searchParams);
    }

    setDraft(response.data.data);
    setDraftUuid(response.data.data.uuid);
    // The link replaces the basket: an order an earlier Payment Element attempt left is not its to retry.
    setRetryOrderUuid(null, response.data.data.company_id);

    return ReduxActions.batchActions([
      actionCreators.order.updateOrder(response.data.data),
      actionCreators.basket.set({
        company_id: response.data.data.company_id,
        items: response.data.data.line_items,
      }),
    ]);
  }

  return null;
}
